<template>
    <v-container>
       
        <v-layout row wrap >
            <v-flex xs12 sm6 class="text-sm-center text-ss-left"> 
                <v-carousel>
                 <v-carousel-item
                
            v-for="pic in pics"
            :src="pic.src"
            :key="pic.id"
            >
            <div class="title">
              {{ pic.title }}
            </div>
          </v-carousel-item></v-carousel>
            </v-flex>
        </v-layout> 
    </v-container>
</template>
<script>
  export default {
    computed:{
      pics() {
        return this.$store.getters.loadPictures
      }
    }
  }
</script>

<style scoped>
  .title {
    position: absolute;
    bottom: 50px;
    background-color: rgba(0,0,0,0.5);
    color: white;
    font-size: 2em;
    padding: 20px;
  }
</style>
